"use client";
import React from "react";
import { Rte } from "@bfl-ui-toolkit/rte";
import { IRTE } from "../../interfaces/IAMCContent.interface";
import { IAmcDetails } from "../../interfaces/AMCChartData.interface";
import { replacePlaceholders } from "@repo/shared-utils/common-utils";

interface AMCRTEDataProps {
  AMCRTEDataPropsData: IRTE;
  companyName: string;
  amcDetails: IAmcDetails;
}

const DEFAULT_COLLAPSED_MAX_HEIGHT = 50;

const parseCollapsedMaxHeight = (value?: number | string): number => {
  if (value === undefined || value === null || value === "") {
    return DEFAULT_COLLAPSED_MAX_HEIGHT;
  }

  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : DEFAULT_COLLAPSED_MAX_HEIGHT;
};

const parseAemBoolean = (value?: string | boolean): boolean | undefined => {
  if (value === undefined || value === null || value === "") {
    return undefined;
  }

  if (typeof value === "boolean") {
    return value;
  }

  return value.toLowerCase() === "true";
};

export const AmcRte: React.FC<AMCRTEDataProps> = ({ AMCRTEDataPropsData, amcDetails }) => {
  const {
    title = "",
    description = "",
    showless = "Show Less",
    showmore = "Show More",
    collapsedMaxHeight,
    defaultExpanded,
    defaultContentExpanded,
    showMoreToggle,
  } = AMCRTEDataPropsData || {};

  const info = amcDetails?.info;

  const {
    aum = "",
    schName = "",
    navDate = "",
    mainCategory = "",
    amcName = "",
    launchDt = "",
    category = "",
    threeYrRet = "",
    fiveYrRet = "",
    oneYrRet = "",
    ratios: { expRatio = "" } = {},
  } = info;

  const dynamicData = {
    schName: schName ?? "",
    aum: aum ? String(aum) : "",
    navDate: navDate ?? "",
    expRatio: expRatio ? String(expRatio) : "",
    mainCategory: mainCategory ?? "",
    amcName: amcName ?? "",
    launchDt: launchDt ?? "",
    category: category ?? "",
    threeYrRet: threeYrRet ? String(threeYrRet) : "",
    fiveYrRet: fiveYrRet ? String(fiveYrRet) : "",
    oneYrRet: oneYrRet ? String(oneYrRet) : "",
  };

  const updatedTitle = replacePlaceholders(title, dynamicData);
  const updatedDescription = replacePlaceholders(description, dynamicData);

  return (
    <div className="mb-3 md:px-5 md:py-2">
      <Rte
        collapsedMaxHeight={parseCollapsedMaxHeight(collapsedMaxHeight)}
        content={updatedDescription}
        defaultContentExpanded={parseAemBoolean(defaultContentExpanded)}
        defaultExpanded={parseAemBoolean(defaultExpanded)}
        heading={updatedTitle}
        headingChevronSize={14}
        headingChevronSizeMd={20}
        headingChevronStrokeWidth={1.5}
        headingChevronStrokeWidthMd={1.5}
        showLessLabel={showless}
        showMoreLabel={showmore}
        showMoreToggle={parseAemBoolean(showMoreToggle)}
        toggleIconSize={21}
        toggleIconSizeMd={24}
        toggleIconStrokeWidth={1.5}
        toggleIconStrokeWidthMd={1.5}
      />
    </div>
  );
};

export default AmcRte;
